export default {}

const login = {
  es: {
    'Sign In': 'Ingresar',
    'Forget your password? ': '¿Olvidó su contraseña?',
    'Sign in to your account': 'Ingresar a la plataforma',
    'Reset password': 'Cambiar contraseña',
    Hello: 'Bienvenido ',
    Change: 'Cambiar',
    'Enter your username': 'Ingresa tu nombre de usuario',
    'Enter your password': 'Ingresa tu contraseña',
    'Resend Code': 'Reenviar codigo',
  },
}
export { login }
